import { Eyebrow } from "../atoms/Eyebrow";
import { Reveal } from "../atoms/Reveal";
import type { Copy } from "../lib/copy";
import { CUSTOMER_LOGOS } from "../lib/copy";

type CasesProps = { t: Copy };

export function Cases({ t }: CasesProps) {
  return (
    <section id="cases" className="section cases">
      <div className="container">
        <div className="section-head wide">
          <Reveal>
            <Eyebrow>{t.cases.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal as="h2" className="section-title" delay={60}>
            <span className="ink">{t.cases.title_a}</span>{" "}
            <span className="serif-accent">{t.cases.title_b}</span>
          </Reveal>
        </div>

        <div className="customer-logos">
          {CUSTOMER_LOGOS.map((n, i) => (
            <Reveal key={i} className="customer-logo" delay={i * 30}>
              {n}
            </Reveal>
          ))}
        </div>

        <div className="quote-grid">
          {t.cases.quotes.map((q, i) => (
            <Reveal key={i} className="quote-card" delay={i * 80}>
              <div className="qc-mark">&ldquo;</div>
              <p className="qc-text">{q.text}</p>
              <div className="qc-who">
                <div className="qc-avatar" />
                <div>
                  <div className="qc-name">{q.who}</div>
                  <div className="qc-role">{q.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
